import { makeBox } from "@seneca/senekit";

import { ReactComponent as iconGoStudent } from "common/assets/images/logo/goStudentLearning-logo.svg";
import { ReactComponent as iconGoogle } from "common/assets/images/sso/google.svg";
import { ReactComponent as iconMicrosoft } from "common/assets/images/sso/microsoft.svg";
import { ReactComponent as iconPlurall } from "common/assets/images/sso/plurall.svg";

export const IconGoogle = makeBox(iconGoogle);
export const IconMicrosoft = makeBox(iconMicrosoft);
export const IconPlurall = makeBox(iconPlurall);
export const IconGoStudent = makeBox(iconGoStudent);
